import React, {useState, useEffect, useRef} from "react";
import {
    Grid,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Modal
} from "@mui/material";
import {connect} from "react-redux";
import {
    listFunctionTemplates,
    updateFunctionTemplate,
    unsetFunction,
    setEmptyAction,
    deleteFunctionTemplate,
    setFunction,
    removemeFunctionTemplate
} from "../../../function.actions";
import { getOrganization } from "../../../../municipality/municipality.actions";
import { ButtonPrimary } from "../../../../../components/newComponents/ButtonPrimary";
import { ButtonSecondary } from "../../../../../components/newComponents/ButtonSecondary";
import { CompDropdownNew } from "../../../../../components/newComponents/DropdownNew";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import { SearchDropdown } from "../../../../../components/newComponents/SearchDropdown";
import { CompDialog } from "../../../../../components/newComponents/CompDialog";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {handleCurrentDateCalulcations} from "../../../components/functionFormComponentUtils";
import {hasPermission, PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, ROLE_EMPLOYEE_MUNICIPALITY, PERMISSION_EDIT_OWN_FUNCTION_TEMPLATE} from "../../../../../permissions";
import { CompSearchInputNew } from "../../../../../components/newComponents/SearchInputNew";
import {useTranslation} from "react-i18next";
import {CompCheckbox} from "../../../../../components/Checkbox";
import {generateKey, getComparator, isFunction} from "../../../../../utils";
import {selectButtonType} from "../../../../../components/utils";
import {listLocations} from "../../../../location/location.actions";
import {
    getOrganizationTree,
    listMunicipalityUsersSilent,
    listOrganizations
} from "../../../../municipality/municipality.actions";
import {updateContentIdentifierChoices} from "../../../../root/root.actions";

const FunctionTemplateTopComponent = (props) => {
    const {
        onChange,
        func,
        editorActivated,
        templates,
        authenticatedUser,
        setFunction,
        showOptions,
        selectedFunction,
        organizationTree,
        selectedMunicipalityUsers,
        selectedTemplateHandlers,
        toggleShowOptions,
        municipalities,
        deleteClicked,
        closeDeleteModal,
        onTemplateSelect
    } = props;
    const {t} = useTranslation('translation');
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [templateList, setTemplateList] = useState([]);
    const [userMunicipality, setUserMunicipality] = useState("");
    const [municipalityList, setMunicipalityList] = useState([]);
    const permissionToCreateFunctionBehalfOfAnother = hasPermission(PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, authenticatedUser);
    const isEmployee = hasPermission(PERMISSION_EDIT_OWN_FUNCTION_TEMPLATE, authenticatedUser)

    useEffect(() => {
        const comparator = getComparator();
        const response = [];
        for (var municipality of municipalities) {
            response.push(municipality);
        }
        response.sort((a, b) => comparator.compare(a.name,b.name));
        setMunicipalityList(response);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [municipalities])

    const shared = false;
    const disableAll = false;
    const municipalitySelect = hasPermission(PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, authenticatedUser);
    const addMunicipalityDefinition = false;
    const [state, setState] = useState({})

    const [showDeleteTemplate, setShowDeleteTemplate] = useState(false);
    const [showEditTemplate, setShowEditTemplate] = useState(false);
    const [showRemovemeTemplate, setShowRemovemeTemplate] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [owner, setOwner] = useState(false)
    const [isTemplateHandler, setIsTemplateHandler] = useState(false)
    const [removeMeDialogOpen, setRemoveMeDialogOpen] = useState(false)

    const handleClose = () => {
        setIsSearchOpen(false);
    };
    const handleRemoveMeClose = () => {
        setRemoveMeDialogOpen(false)
    }
    const searchInputRef = useRef();
    //const theme = useTheme();
    //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const templateChoice = [
        {
            label: t('function.public_function_template'),
            key: "municipalityTemplate",
            value: selectedFunction.municipalityTemplate
        }
    ]
    const allowTemplateGroupEditing = [
        {
            label: t('function.allow_template_group_editing'),
            key: "allowTemplateGroupEditing",
            value: selectedFunction.allowTemplateGroupEditing
        }
    ]
    
    //NOTE, MUI requires the use of "event" in checkbox components. Removing it will cause the checkbox to fail to work.
    //Please stick on using event.target.checked on checkboxes atleast
    const handleSelectChange = (event) => {
        setFunction({
            ...selectedFunction,
            municipalityTemplate: event.target.checked
        })
    }
    const handleGroupEditingChange = (event) => {
        setFunction({
            ...selectedFunction,
            allowTemplateGroupEditing: event.target.checked
        })
    }

    const handleChange = (event, changedData) => {
        let data = {
            ...selectedFunction,
            [event.target.name]: event.target.value
        }
        if (changedData) {
            data = {
                ...selectedFunction,
                ...changedData
            }
        }
        setFunction(data);
        if (isFunction(onChange)) {
            onChange(event)
        }
    };

    const handleTemplateDelete = (event) => {
        const data = {...selectedTemplate}
        const templateId = data.id
        actualDeleteTemplate(event, templateId, data)
    }

    const actualDeleteTemplate = (event, templateId, data) => {
        event.preventDefault();

        //null check to prevent application crash´
        if(!templateId) return;

        const functionData = { ...data };
        
        if (!functionData['municipalityId']) {
            functionData['municipalityId'] = props.selectedMunicipality.id;
        }

        props.deleteFunctionTemplate(templateId, data => {
            props.unsetFunction()
            props.listFunctionTemplates(functionData['municipalityId']);
            window.location.reload();
           
            return setEmptyAction(data);
        });
    }

    const actualRemovemeTemplate = (event) => {
        event.preventDefault();
        props.removemeFunctionTemplate(selectedTemplate.id, data => {
            //set default municipality to user mainmunicipalityId
            props.listFunctionTemplates(authenticatedUser.mainMunicipalityId);
            setState({
                ...state,
                removemeTemplateModalOpen: false
            });
            setRemoveMeDialogOpen(false)
            resetTemplate(false)
            return setEmptyAction(data);
        });
    }

    let functionTemplateButtons = [
        {
            id: "removeme",
            type: "attention",
            label: t("function.remove_me_from_function_template"),
            className: "",
            onClick: () => setRemoveMeDialogOpen(true)
        }
    ];
    if (state.readOnly) {
        functionTemplateButtons = [];
    }

    const handleTemplateChangeById = (templateId) => {
        const selectedTemplate = templates.find(t => t.id === parseInt(templateId));

        if (!selectedTemplate) {
            resetTemplate(true)
            return;
        }

        const isOwner = selectedTemplate.creatorId === authenticatedUser.id;
        setOwner(isOwner)
        const isHandler = selectedTemplate.templateHandlers?.some((t) => t.id === authenticatedUser.id);
        if (selectedTemplate.allowTemplateGroupEditing && isHandler) {
            setOwner(true)
        }

        setShowRemovemeTemplate(isHandler && !isOwner);

        if (!permissionToCreateFunctionBehalfOfAnother) {
            setShowDeleteTemplate(true);
            setShowEditTemplate(true);
        } else if (isOwner) {
            setShowDeleteTemplate(true);
            setShowEditTemplate(true);
        } else {
            setShowDeleteTemplate(false);
            setShowEditTemplate(false);
        }

        const newTemplate = { ...selectedTemplate };
        setSelectedTemplate(newTemplate);
        onTemplateSelect(newTemplate);

        const { id, ...data } = structuredClone(selectedTemplate);

        if (!permissionToCreateFunctionBehalfOfAnother) {
            if (!data.organizers.find((o) => o.id === authenticatedUser.id)) {
                data.organizers.unshift(authenticatedUser);
            }
        }

        handleCurrentDateCalulcations(data);
        if (!showOptions) toggleShowOptions();
        setFunction(data);
    };

    const permanentTemplateHandlers = [];
    const selectedTemplateHandlersRows = [];

    if (!permissionToCreateFunctionBehalfOfAnother && (selectedFunction.id === null || selectedFunction.id === undefined)) {
        permanentTemplateHandlers.push(authenticatedUser.id);
    }
    if ('templateHandlers' in selectedFunction) {
        selectedFunction.templateHandlers.forEach(function (handler) {
            selectedTemplateHandlersRows.push(handler.id);
        });
    } else if (editorActivated) {
        selectedMunicipalityUsers.forEach((user) => {
            if (user.id === authenticatedUser.id)
                selectedFunction.templateHandlers = [user];
        });
        selectedTemplateHandlersRows.push(authenticatedUser.id);
    }

    const createTemplateLabel = (template) => {
        let name = template.templateName;
        if (template.municipalityTemplate) {
            name += " - " + t('function.public_template');
        }
        else if (template.templateHandlers.length > 1) {
            name += " - " + t('function.group_template');
        }
        else {
            name += " - " + t('function.private_template');
        }
        return name;
    }

    const getFunctionTemplateOptions = () => {
        const response = [];
        for (const i in templates) {
            const template = templates[i];
            response.push({value: template.id, label: createTemplateLabel(template), template: template})
        }
        return response;
    }

    const getCreatorName = (creatorId) => {
        const organizer = selectedFunction?.organizers?.find(o => o.id === creatorId);
        if (organizer) return `${organizer.firstName} ${organizer.lastName}`;

        const handler = selectedFunction?.templateHandlers?.find(h => h.id === creatorId);
        if (handler) return `${handler.firstName} ${handler.lastName}`;

        return "Toimintapohjan tekijää ei löytynyt"; //TODO translations
    };

    const selectTemplateHandler = (row, isAddAction) => {
        let value = [];
        if ('templateHandlers' in selectedFunction) {
            value = [...selectedFunction.templateHandlers];
        }
        
        if (isAddAction) {
            value.push(row);
        } else {
            const indexToRemove = value.findIndex(item => item.id === row.id);
            if (indexToRemove !== -1) {
                value.splice(indexToRemove, 1);
            }
        }

        const data = {
            target: {
                value: value,
                name: "templateHandlers",
            },
        };
        handleChange(data);
    }

    let editFunctionTemplateButton = null;
    let deleteFunctionTemplateButton = null;
    let removemeFunctionTemplateButton = null;

    const handleFunctionTemplateClick = (event, callback) => {
        event.preventDefault();
        const data = {...selectedFunction};
        callback(event, data, selectedTemplate, props.selectedMunicipality);
    };

    if (functionTemplateButtons) {
        let componentFunctionTemplateButtons = [];
        functionTemplateButtons.forEach( function (button) {
            const key = generateKey('funcTemplateButton');
            selectButtonType(button, componentFunctionTemplateButtons, key, handleFunctionTemplateClick, button.id);
        })
        componentFunctionTemplateButtons.forEach(button => {
            if (button.props.buttonIdentifier === "edit") {
                editFunctionTemplateButton = button;
            }
            else if (button.props.buttonIdentifier === "delete") {
                deleteFunctionTemplateButton = button;
            }
            else {
                removemeFunctionTemplateButton = button;
            }
        })

    }

    const getCurrentMunicipality = () => {
        //load user municipality data on page load/refresh
        //props.userMunicipality
        setUserMunicipality(props.userMunicipality)
        props.listFunctionTemplates(authenticatedUser.mainMunicipalityId);
        props.listLocations(authenticatedUser.mainMunicipalityId);
        props.listMunicipalityUsersSilent(authenticatedUser.mainMunicipalityId);
        props.listOrganizations(authenticatedUser.mainMunicipalityId);
        props.getOrganizationTree(authenticatedUser.mainMunicipalityId, 10);
        props.updateContentIdentifierChoices(authenticatedUser.mainMunicipalityId);
    }

    const handleMunicipalityChange = (event, doNotUpdateFunction) => {
        let selectedMunicipality = {}
        municipalities.forEach((municipality) => {
            if (municipality.id === parseInt(event.target.value)) {
                selectedMunicipality = municipality;
            }
        })
        const data = {}
        data['municipalityId'] = selectedMunicipality.id;
        setSelectedTemplate(null);
        onTemplateSelect(null);
        props.listFunctionTemplates(selectedMunicipality.id);
        props.listLocations(selectedMunicipality.id);
        props.listMunicipalityUsersSilent(selectedMunicipality.id);
        props.listOrganizations(selectedMunicipality.id);
        props.getOrganizationTree(selectedMunicipality.id, 10);
        props.updateContentIdentifierChoices(selectedMunicipality.id);
        if (!doNotUpdateFunction) {
            props.setFunction(data);
        }
    };

    useEffect(() => {
        getCurrentMunicipality()
    }, [])

    useEffect(() => {
        setTemplateList(getFunctionTemplateOptions());
        setSelectedTemplate(null);
        onTemplateSelect(null);
    }, [func.templates])

    const handleReset = () => {
        selectedFunction.locationId = null
        selectedFunction.organizationId = null
        searchInputRef.current?.closeSearchList();
    };

    const handleTemplateDropdownChange = (event) => {
        const targetValue = event.target?.value;
        handleTemplateChangeById(targetValue);
    };

    const handleDialogTemplateChange = (event) => {
        handleTemplateChangeById(event.originalTemplate.id)
    }

    const resetTemplate = (isClear) => {
        if(!isClear) {
            toggleShowOptions()
        }
        setSelectedTemplate(null)
        onTemplateSelect(null);
        props.unsetFunction()
    }

    const openDialog = () => {
        setIsSearchOpen(true); 
        handleReset()
    }

    return (
        <>
            <Grid size={12}>
                <CompPartitionHeader text={t("function.function_template")}/>
                <Typography className={'modalDescription'} tabIndex={0}>
                    {t("function.template_instructions")}
                </Typography>
                <Grid container spacing={2} className="func-top-wrapper" sx={{paddingLeft: "0px !important", marginTop: "2vh"}}>
                <CompDialog 
                    organizationTree={organizationTree}
                    open={isSearchOpen}
                    onClose={handleClose}
                    onTemplateSelected={handleDialogTemplateChange}
                    selectedFunction={selectedFunction}
                />
                <Dialog
                    open={removeMeDialogOpen}
                    onClose={handleRemoveMeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('reminder.userWillBeInactivatedMissing')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {t('function.removeme_template_question')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonSecondary
                            key={'cancel'}
                            onClick={handleRemoveMeClose}>
                            {t('common.cancel')}
                        </ButtonSecondary>
                        <ButtonPrimary
                            key={'removemeTemplate'}
                            onClick={actualRemovemeTemplate}>
                            {t('function.remove_me_from_function_template')}
                        </ButtonPrimary>
                    </DialogActions>
                </Dialog>
                    <Modal open={deleteClicked} onClose={closeDeleteModal}>
                        <div className={'modal archiveModal'}>
                            <div className={'modalQuestion'}>
                                {t('function.delete_template_question_part1')} {selectedTemplate?.templateName} {t('function.delete_template_question_part2')}
                            </div>
                            <div className={'modalButtons'}>
                                <ButtonSecondary
                                    key={'cancel'}
                                    onClick={closeDeleteModal}>
                                    {t('common.cancel')}
                                </ButtonSecondary>
                                <ButtonPrimary
                                    key={'deleteTemplate'}
                                    onClick={handleTemplateDelete}>
                                    {t('function.delete_function_template')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    </Modal>
                    <Grid item gap={2} size={{xs: 12, sm: 6}} sx={{alignContent: "center"}}>
                        {municipalitySelect ?
                            <CompDropdownNew
                                label={t('common.municipality')}
                                className={'function-dropdown municipality-select'}
                                valueColumn={"id"}
                                labelColumn={"name"}
                                rows={municipalityList}
                                hasEmptyOption={false}
                                /* error={fieldErrors.municipalityId} */
                                onChange={handleMunicipalityChange}
                                disabled={!editorActivated}
                                name="municipalityId"
                                selectedValue={selectedFunction.municipalityId}
                            />
                            :
                            <CompTextFieldNew
                                label={t('common.municipality')}
                                isLabelShrink={true}
                                value={userMunicipality.name}
                                disabled={true}
                                /* error={fieldErrors.municipalityId} */
                                name="municipalityId"
                            />
                        }
                        
                        <Grid item sx={{marginTop: '2vh'}}>
                            <SearchDropdown
                                label={t('function.saved_function_templates')}
                                selectedValue={selectedTemplate ? selectedTemplate.id : ""}
                                rows={getFunctionTemplateOptions()}
                                disabled={disableAll}
                                name="template"
                                onChange={handleTemplateDropdownChange}
                            />
                        </Grid>
                        <Grid item sx={{width: '100% !important'}} size={{xs: 12, sm: 6}}>
                            <ButtonPrimary className='show-template-btn' onClick={() => resetTemplate(false)}>
                                {showOptions ? t('function.cancel') : t('function.create_new_template')}
                            </ButtonPrimary>
                            <ButtonPrimary className='show-template-btn' type="button" variant="contained" onClick={/* () => setDialogOpen(true) */openDialog}>
                                {t('function.search_template')}
                            </ButtonPrimary>
                        </Grid>
                    </Grid>
                </Grid>
                {showOptions && (
                    <>
                        <Grid container>
                            <Grid className={'align-right'} size={12}>
                                <div className={"buttonSpacer"}>
                                    {showEditTemplate && editFunctionTemplateButton}
                                    {showDeleteTemplate && deleteFunctionTemplateButton}
                                </div>
                            </Grid>
                        </Grid>
                            <CompPartitionHeader text={t("function.function_template_usage")}/>
                            <Typography className={'modalDescription'} sx={{marginBottom: "2vh"}}>
                                {t("function.function_template_usage_description")}
                            </Typography>
                        <Grid container spacing={2} sx={{paddingLeft: "0px !important"}}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Grid container spacing={2} sx={{paddingLeft: "0px !important"}}>
                                    <Grid size={{ xs: 12, sm: 12 }}>
                                        {editorActivated && <CompSearchInputNew
                                            label={`${t('function.template_handlers')}`}
                                            multiselect
                                            isLabelShrink={true}
                                            rows={selectedTemplateHandlers}
                                            keyColumn={'id'}
                                            valueColumn={municipalitySelect && addMunicipalityDefinition ? ['firstName', 'lastName', [municipalities, 'mainMunicipalityId']]: ['firstName', 'lastName']}
                                            disabled={disableAll}
                                            activeUserId={authenticatedUser.id}
                                            selectedRows={selectedTemplateHandlersRows}
                                            permanentSelections={permanentTemplateHandlers}
                                            isOwner={owner}
                                            isTemplateHandler={isTemplateHandler}
                                            authenticatedUser={authenticatedUser}
                                            name="templateHandlers"
                                            hasPermissionToEdit={isEmployee}
                                            /* error={fieldErrors.templateHandlers} */
                                            onSelect={selectTemplateHandler}
                                        />}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    {showRemovemeTemplate && removemeFunctionTemplateButton}
                                </Grid>
                                <Grid>
                                    <CompCheckbox
                                        booleanmode={true}
                                        rows={allowTemplateGroupEditing}
                                        selected={selectedFunction}
                                        disabled={disableAll}
                                        onChange={handleGroupEditingChange}
                                        name={"allowTemplateGroupEditing"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={{xs: 12, sm: 6}}>
                                <CompTextFieldNew
                                    label={`${t('function.template_creator_name')}`}
                                    value={selectedTemplate ? getCreatorName(selectedFunction.creatorId) : authenticatedUser.firstName + " " + authenticatedUser.lastName}
                                    disabled={true}
                                    isLabelShrink={true}
                                    name="templateCreator"
                                    /* error={fieldErrors.templateCreator} */
                                />
                                {permissionToCreateFunctionBehalfOfAnother &&
                                    <CompCheckbox
                                        booleanmode={true}
                                        rows={templateChoice}
                                        selected={selectedFunction}
                                        disabled={disableAll}
                                        onChange={handleSelectChange}
                                        name={"feedbackChoices"}
                                    />
                                }
                                <CompTextFieldNew
                                    label={`${t('function.template_name')}*`}
                                    value={selectedFunction.templateName}
                                    disabled={disableAll}
                                    isLabelShrink={true}
                                    name="templateName"
                                    /* error={fieldErrors.templateName} */
                                    onChange={handleChange}
                                />
                                <CompTextFieldNew
                                    label={t('function.template_description')}
                                    value={selectedFunction.templateDescription}
                                    disabled={!editorActivated && !shared}
                                    isLabelShrink={true}
                                    name="templateDescription"
                                    multiline
                                    rows={6}
                                    /* error={fieldErrors.templateDescription} */
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    // return state;
    return {
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        selectedMunicipalityUsers: state.municipality.selectedMunicipalityUsers,
        selectedTemplateHandlers: state.municipality.selectedTemplateHandlers,
        userMunicipality: state.municipality.selectedMunicipality,
        municipalities: state.municipality.municipalities,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data)),
        listMunicipalityUsersSilent: (municipalityId) => dispatch(listMunicipalityUsersSilent(municipalityId)),
        listFunctionTemplates: (municipalityId) => dispatch(listFunctionTemplates(municipalityId)),
        unsetFunction: () => dispatch(unsetFunction()),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        updateFunctionTemplate: (templateId, data, onSuccess) => dispatch(updateFunctionTemplate(templateId, data, onSuccess)),
        getOrganization: (municipalityId, id) => dispatch(getOrganization(municipalityId, id)),
        deleteFunctionTemplate: (templateId, onSuccess) => dispatch(deleteFunctionTemplate(templateId, onSuccess)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getOrganizationTree: (municipalityId, level) => dispatch(getOrganizationTree(municipalityId, level)),
        updateContentIdentifierChoices: (municipalityId) => dispatch(updateContentIdentifierChoices(municipalityId)),
        removemeFunctionTemplate: (templateId, onSuccess) => dispatch(removemeFunctionTemplate(templateId, onSuccess))
    };
}

export const FunctionTemplateTopComp = connect(mapStateToProps, mapDispatchToProps)(FunctionTemplateTopComponent);
